import axios from "axios";

export interface S3UploadResponse {
    url: string;
    objectKey: string;
    fileName: string;
    fileSize: number;
}

/**
 * 파일을 S3에 업로드 (서버를 통해)
 * @param file 업로드할 파일
 * @param folder S3 버킷 내 폴더 (기본값: "ads")
 * @param onProgress 업로드 진행률 콜백
 * @returns S3 URL 및 메타데이터
 */
export const uploadToS3 = async (
    file: File,
    folder: string = "ads",
    onProgress?: (progress: number) => void
): Promise<S3UploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("folder", folder);

    const baseURL = process.env.REACT_APP_API_DOMAIN || "http://localhost:5039/v0";

    try {
        const response = await axios.post<S3UploadResponse>(`${baseURL}/S3Upload/Upload`, formData, {
            headers: {
                "Content-Type": "multipart/form-data",
            },
            onUploadProgress: (progressEvent: any) => {
                if (onProgress && progressEvent.total) {
                    const percentCompleted = Math.round(
                        (progressEvent.loaded * 100) / progressEvent.total
                    );
                    onProgress(percentCompleted);
                }
            },
        });

        return response.data;
    } catch (error: any) {
        console.error("S3 Upload Error:", error);
        console.error("Error Response:", error.response?.data);
        console.error("Error Status:", error.response?.status);
        console.error("Error Headers:", error.response?.headers);
        throw new Error(error.response?.data?.message || error.message || "S3 업로드 실패");
    }
};
